// Web module: maintenance inbox. Generic list and detail pages. Columns and filters come from
// the entity (list and filter flags). This entry replaces the schema nav item so it has a label
// under Settings. updatedAt is a default column through DEFAULT_COLUMN_EXTRAS in fields.ts.
import type { WebModule } from '../../lib/modules'

/** Columns the inbox wants on the generic list, in order. */
export const MAINTENANCE_LIST_COLUMNS = [
  'title',
  'severity',
  'status',
  'source',
  'area',
  'updatedAt',
] as const
/** Filters on the generic list. */
export const MAINTENANCE_FILTERS = ['severity', 'status', 'source'] as const

export const module: WebModule = {
  routes: [],
  entityOverrides: {},
  nav: [
    {
      key: 'maintenance_ticket',
      label: 'Maintenance inbox',
      to: '/maintenance-tickets',
      group: 'Settings',
      order: 40,
      entity: 'maintenance_ticket',
      module: 'maintenance',
    },
  ],
}
